const AMOUNT_FORMAT: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 2 };

/**
 * The one wording for "the partner sent no currency for this price", used by
 * the enrichment form, the synced-location pricing card and the publish
 * preview alike.
 */
export const CURRENCY_NOT_SET_LABEL = 'Currency not set';

/**
 * Formats an amount in the currency it is stored in, without ever throwing.
 *
 * - No currency (the partner sent none): the bare amount, so no symbol is
 *   invented.
 * - A code Intl cannot format (partner data is not validated, and
 *   `Intl.NumberFormat` throws RangeError on anything but a well-formed
 *   three-letter code): the amount followed by the code as sent.
 */
export function formatMoney(amount: number, currency: string | null): string {
  const plain = new Intl.NumberFormat('en-US', AMOUNT_FORMAT).format(amount);
  if (currency === null || currency === '') {
    return plain;
  }
  try {
    return new Intl.NumberFormat('en-US', { ...AMOUNT_FORMAT, style: 'currency', currency }).format(amount);
  } catch {
    return `${plain} ${currency}`;
  }
}
